import { render, staticRenderFns } from "./diyPoster.vue?vue&type=template&id=36ff843c&scoped=true&"
import script from "./diyPoster.vue?vue&type=script&lang=js&"
export * from "./diyPoster.vue?vue&type=script&lang=js&"
import style0 from "./diyPoster.vue?vue&type=style&index=0&id=36ff843c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ff843c",
  null
  
)

export default component.exports